'use strict';

var variables = require('./variables-1eb6495a.js');

// see https://material-ui-pickers.dev/guides/css-overrides
const light = {
    day: {
        "&&&:hover": {
            backgroundColor: variables.COLORS.GREYSCALE_0_03,
        },
    },
    daySelected: {
        "&&&:hover": {
            backgroundColor: variables.COLORS.GREEN,
        },
    },
};

var MuiPickersDay = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiPickersDay = MuiPickersDay;
exports.light = light;
